import React from "react"
import Header from "components/headers/header"
import Footer from "components/footers/footer"
import { useCompanyData } from "hooks/use-company-data"
import { useSiteData } from "hooks/use-site-data"
import styled from "@emotion/styled"
import { BaseStyles, Link } from "theme-ui"
import Seo from "components/seo"
import { Link as GatsbyLink } from "gatsby"
import "assets/css/layout.css"
import "assets/css/fontsize.css"
import CookieConsent from "react-cookie-consent"

const ContentWrap = styled.div`
    // width: 100vw;
    flex: 1 1 auto;
`

const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
`

const Layout = (props) => {
    const company = useCompanyData()

    const { page, metadata, location } = props
    const domain = location ? location.origin : company.website
    const companySchema = {
        "@context": "https://www.schema.org",
        "@type": "Organisation",
        name: company.name,
        image: `${domain}${company.company_logo.publicURL}`,
        "@id": "",
        url: company.website,
        telephone: company.tel,
        address: {
            "@type": "PostalAddress",
            streetAddress: company.address,
            addressLocality: company.addressCountry,
            postalCode: company.postalCode,
            addressCountry: company.addressCountry,
        },
        geo: {
            "@type": "GeoCoordinates",
            latitude: 1.3061667,
            longitude: 103.8284991,
        },
    }
    const schema = props.schema || companySchema
    const description = metadata
        ? metadata.description
        : company.metadata.description
    const seoTitle = metadata
        ? metadata.title
        : `${page.title} | ${company.name}`
        
    const ogImage =
        metadata && metadata.OG_image
            ? metadata.OG_image.childImageSharp.resize.src
            : page.image
            ? page.image.childImageSharp.resize.src
            : ""

    return (
        <>
            {/* Seo({ description, lang, meta, title, schema,location,image }) */}
            <CookieConsent
                style={{ fontSize: "16px", background: "#333" }}
                buttonStyle={{
                    background: "#712AA7",
                    color: "#FFF",
                    fontSize: "16px",
                    padding: "8px 16px",
                    marginRight: "84px",
                }}
                buttonText="Got it!"
            >
                This website uses cookies to ensure you get the best experience
                on our website.{" "}
                <Link
                    to="/cookies-policy"
                    as={GatsbyLink}
                    sx={{ color: "#FFF", textDecoration: "underline" }}
                >
                    Learn more
                </Link>
            </CookieConsent>
            <Seo
                description={description}
                title={seoTitle}
                schema={schema}
                meta={metadata}
                location={location}
                image={ogImage}
            />
            <MainContainer sx={{ variant: "theme.styles" }}>
                <Header company={company}></Header>
                <BaseStyles>
                    <ContentWrap>{props.children}</ContentWrap>
                </BaseStyles>
                <Footer company={company}></Footer>
            </MainContainer>
        </>
    )
}

export default Layout
